// Web-only strings for voice notes (keys prefixed `web.voice.`), BOTH languages. Apple keys are
// used wherever they exist: channel.recording / channel.recordingPaused (the strip), channel.voiceNote
// (the card's label), channel.voicePause / channel.voiceResume, channel.voiceSkipBack / Forward.
// The apps never need the microphone sentences: their OS asks once and the app button simply does
// nothing on a refusal. A browser's refusal is sticky and invisible, so the web must SAY it.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.voice.record': 'Grabar nota de voz',
    'web.voice.send': 'Enviar nota de voz',
    'web.voice.discard': 'Descartar la nota',
    'web.voice.play': 'Reproducir',
    'web.voice.pause': 'Pausar',
    'web.voice.rate': 'Velocidad de reproducción',
    'web.voice.seek': 'Posición en la nota',
    'web.voice.level': 'Nivel del micrófono',
    'web.voice.denied': 'Satori Chat no tiene permiso para usar el micrófono. Permítelo desde el candado junto a la dirección de la página y vuelve a intentarlo.',
    'web.voice.noDevice': 'No se encontró ningún micrófono. Conecta uno y vuelve a intentarlo.',
    'web.voice.busy': 'Otra aplicación está usando el micrófono. Ciérrala y vuelve a intentarlo.',
    'web.voice.unsupported': 'Este navegador no puede grabar notas de voz.',
    'web.voice.failed': 'No se pudo grabar la nota de voz. Vuelve a intentarlo.',
    'web.voice.playFailed': 'No se pudo reproducir',
  },
  en: {
    'web.voice.record': 'Record a voice message',
    'web.voice.send': 'Send voice message',
    'web.voice.discard': 'Discard the recording',
    'web.voice.play': 'Play',
    'web.voice.pause': 'Pause',
    'web.voice.rate': 'Playback speed',
    'web.voice.seek': 'Position in the message',
    'web.voice.level': 'Microphone level',
    'web.voice.denied': 'Satori Chat is not allowed to use the microphone. Allow it from the lock next to the page address and try again.',
    'web.voice.noDevice': 'No microphone was found. Connect one and try again.',
    'web.voice.busy': 'Another app is using the microphone. Close it and try again.',
    'web.voice.unsupported': 'This browser cannot record voice messages.',
    'web.voice.failed': 'The voice message could not be recorded. Try again.',
    'web.voice.playFailed': 'Could not play',
  },
};
